export function getItfRecordId(data) {
  if (!data || typeof data !== 'object') return ''

  const raw = data._id != null ? data._id : data.id
  if (raw == null) return ''

  if (typeof raw === 'object') {
    const nested = raw._id || raw.$oid
    if (nested != null) return String(nested)
    if (typeof raw.toString === 'function') {
      const value = String(raw.toString())
      if (value && value !== '[object Object]') return value
    }
    return ''
  }

  return String(raw)
}
